import * as React from 'react';
import { cn } from '@/lib/utils';

export type WfKpiTone =
  | 'default'
  | 'run'
  | 'appr'
  | 'wait'
  | 'done'
  | 'rej'
  | 'block'
  | 'ready'
  | 'canc';

export interface WfKpiProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Valor grande mono (wireframe .stat .sv). */
  value: React.ReactNode;
  /** Label uppercase (wireframe .stat .sk). */
  label: React.ReactNode;
  /** Tom de cor do valor (wireframe .stat.run/.appr/.wait/.done/.rej/.block/.ready/.canc). */
  tone?: WfKpiTone;
}

/** KPI/stat do wireframe (.stat). Usar dentro de um grid .wf-statgrid. */
export const WfKpi = React.forwardRef<HTMLDivElement, WfKpiProps>(
  ({ value, label, tone = 'default', className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn('wf-kpi', tone !== 'default' && `wf-kpi--${tone}`, className)}
      {...props}
    >
      <div className="wf-kpi-value">{value}</div>
      <div className="wf-kpi-label">{label}</div>
    </div>
  )
);
WfKpi.displayName = 'WfKpi';
